import { useMutation } from 'react-query';

import { axiosWithoutInterceptors } from '@/lib/axios';

type SubscribtionData = {
  name: string;
  city: string;
  email: string;
  street: string;
  postCode: string;
  phoneNumber: string;
  companyEmail: string;
  countryCodeId: string;
  contactLastName: string;
  contactFirstName: string;
  termsAndContractValidated: boolean;
};

type UpdateCrossingRequestedDateType = {
  data: SubscribtionData;
};

const subscribeAsync = ({ data }: UpdateCrossingRequestedDateType) =>
  axiosWithoutInterceptors.post<string>(`/prospects`, data);

export const useSubscribeAsync = () =>
  useMutation({
    mutationFn: subscribeAsync,
  });
